import MyToken from './index';
import Currency from './Currency';
import Ticker from './Ticker';

export default {
  path: '/home/mytoken',
  component: MyToken,
  redirect: '/home/mytoken/currency',
  children: [
    { path: '/home/mytoken/currency', component: Currency },
    { path: '/home/mytoken/ticker', component: Ticker }
  ]
};
